import moment from "moment";
import api from "@/modules/global/lib/api-client.js";

const state = {
  rawEngagementsData: [],
  hasFetchedEngagements: false,
  engEndDate: moment()
    .utc()
    .format("YYYY-MM-DD"),
  engStartDate: moment()
    .subtract(30, "days")
    .utc()
    .format("YYYY-MM-DD")
};

const getters = {
  getRawEngagementsData: state => {
    return state.rawEngagementsData;
  },
  hasFetchedEngagements: state => {
    return state.hasFetchedEngagements;
  }
};

const mutations = {
  setRawEngagementsData(state, engDataPayload) {
    state.rawEngagementsData = engDataPayload;
  },
  setHasFetchedEngagements(state, val) {
    state.hasFetchedEngagements = val;
  }
};

const actions = {
  async fetchRawEngagementsData({ commit, state }, project) {
    const engRequest = await api.get(
      `user-activity/new?project=${project}&startPeriod=${encodeURIComponent(
        state.engStartDate
      )}&endPeriod=${encodeURIComponent(state.engEndDate)}`
    );

    if (engRequest && engRequest.status == 200) {
      const engData = await engRequest.json();
      commit("setRawEngagementsData", engData);
      commit("setHasFetchedEngagements", true);
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};
